
























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class DotToggler extends Vue {
  @Prop({ default: 0 })
  length!: number;

  @Prop()
  value!: string | number;

  onItemChange(value: number) {
    this.$emit('input', value);
  }
}
